import { render } from "./paneThree.vue?vue&type=template&id=6c0419c1&scoped=true"
import script from "./paneThree.vue?vue&type=script&lang=js"
export * from "./paneThree.vue?vue&type=script&lang=js"

import "./paneThree.vue?vue&type=style&index=0&id=6c0419c1&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0419c1"]])

export default __exports__